const messaging = () => ({
  registerDeviceForRemoteMessages: () => {}
});

export default messaging;
